// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
export const firebaseConfig = {
  apiKey: 'AIzaSyCxe7WeI3T2Iw-1xMaPGWEO4zfuSfDe7gY',
  authDomain: 'filmoteka-team-project-j-9925d.firebaseapp.com',
  projectId: 'filmoteka-team-project-j-9925d',
  storageBucket: 'filmoteka-team-project-j-9925d.appspot.com',
  messagingSenderId: '410025843843',
  appId: '1:410025843843:web:481e052239d4c2f1930fb6',
  measurementId: 'G-WJ2KQ7LF58',
};

// Initialize Firebase
